/**
 * MetricsAppFilterButton — 转化 / 留存看板自带的「应用」多选筛选。
 *
 * 这几张看板不跟随顶栏 App 范围，应用在页面内筛选；不选 = 全部（app_ids 不下发）。
 */

import { useApps } from '~/data/queries';
import { FilterButton } from '~/ui/FilterButton';

export function MetricsAppFilterButton({
  value,
  onChange,
}: {
  value: string[];
  onChange: (next: string[]) => void;
}) {
  const { data: apps } = useApps();
  return (
    <FilterButton
      label="应用"
      options={apps.map((app) => ({ value: app.id, label: app.name }))}
      value={value}
      onChange={onChange}
    />
  );
}
